import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportInvoiceRelationshipTypes } from "redux/reducers/Reports/reportInvoiceRelationship/types";

const { SET_REPORT_INVOICE_RELATIONSHIP_FILTERS } = reportInvoiceRelationshipTypes;

export const getReportInvoiceRelationshipAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/invoices/report/pdf?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Relación_Facturas_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportInvoiceRelationship'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportInvoiceRelationship'));
    }
  };
};

export const setReportInvoiceRelationshipFilters = (key = "", value) => {
  return {
    type: SET_REPORT_INVOICE_RELATIONSHIP_FILTERS,
    payload: { value, key },
  };
};
